// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__3lqMB","imageWrapper":"Card_imageWrapper__1OVgP","buttonsWrapper":"Card_buttonsWrapper__2o8Lh"};